import { Expose, Type } from 'class-transformer';
import { Media } from '../../shared-features/models/media.model';
import { Fleet } from './fleet.model';
import { User } from '../../users/models/user.model';
import { Truck } from './truck.model';
import { LicenseType, Nationality } from '../../shared-features/enums/fleets.enum';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { PermittedAccess } from './permitted-access.model';
import { AthrOperationCard } from './athr-card-model';

export class Driver extends DropdownModel {
  @Expose() id: number;
  @Type(() => User)
  @Expose()
  user: User = new User();
  @Type(() => Fleet)
  @Expose()
  fleet: Fleet = new Fleet();
  @Expose() name: string;
  @Expose() iqamaId: number;
  @Expose() nonResidentId: number;
  @Expose() nationality: Nationality;
  @Expose() licenseType: LicenseType;
  @Type(() => Media)
  @Expose()
  licenseAttachment: Media = new Media();
  @Expose() licenseExpiry;
  @Expose() iqamaIdExpiry;
  @Expose() birthDate: Date;
  @Type(() => Truck)
  @Expose()
  truck: Truck = new Truck();
  @Expose() title: string;
  @Expose() email: string;
  @Expose() mobileNumber: string;
  @Expose() code: number;
  @Type(() => Media)
  @Expose()
  logo: Media = new Media();
  @Expose() sendSms: boolean;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() owner: string;
  @Expose() shipmentsCount: number;
  @Expose() distanceInKm: number;
  @Expose() firstName = '';
  @Expose() lastName = '';
  @Expose() permits: PermittedAccess[];
  @Expose() issueNumber: number;
  @Expose() isVerifiedByElm: boolean;
  @Expose() operationCard?: AthrOperationCard;
  @Expose() isVerifiedByAthr?: boolean;
  @Expose() uuid: string;

  constructor() {
    super();
  }

  get fullName(): string {
    return this.user?.firstName + ' ' + this.user?.lastName;
  }

  get dropDownDisplayName(): string {
    return this.user?.firstName + ' ' + this.user?.lastName;
  }

  get dropDownValue(): object {
    return this;
  }
}
